import { IResponseModel } from '@agenda-customer-ui/shared';
import { IUserProfileResponse, IVehicleFromUsers } from '@core/interface';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { COUNTRY_CODE, StorageKeys } from '@core/enums';
import { SessionService } from '../session/session.service';
import { ServiceStorage } from '../../../../../../apps/schedule/src/app/core/service/storage-service/service-storage.service';
import { API, environment } from '@core/envs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private serviceStorage = inject(ServiceStorage);
  private http = inject(HttpClient);
  private sessionService = inject(SessionService);

  postNewUserSave(
    userProfile: IUserProfileResponse,
    regionC: string
  ): Observable<IUserProfileResponse> {
    const api = environment.getRoute(API.users);
    const url = `${api}/customers?region=${regionC}`;

    if (userProfile.nationalIdentification) {
      userProfile.nationalIdentification.subType = userProfile.country?.countryCode === COUNTRY_CODE.BRAZIL ? 'CPF' : 'DNI';
    }

    if (userProfile.address?.addressLine2 && userProfile.address.addressLine2.length > 20) {
      userProfile.address.addressLine3 = userProfile.address.addressLine2.substring(20);
      userProfile.address.addressLine2 = userProfile.address.addressLine2.substring(0, 20);
    }

    return this.http.post<IUserProfileResponse>(url, userProfile)
      .pipe(
        tap(() => {
          this.serviceStorage.user = userProfile;
        })
      );
  }

  updateCustomerInfo(customerReq: any): Observable<IResponseModel<any>> {
    const api = environment.getRoute(API.transformation);
    const url = `${api}/customers`;

    return this.http.put<IResponseModel<any>>(url, customerReq).pipe(
      map((data: IResponseModel<any>) => {
        if (data.response && data.response.status === "402") {
          throw new Error(`Error API Fordpass402`);
        }

        return data;
      })
    );
  }

  get(region = 'SA'): Observable<{ userProfile: IUserProfileResponse; vehicles?: IVehicleFromUsers[] }> {
    const url = `${environment.getRoute(API.users)}/customers?region=${region}`;
    return this.http.get<{ userProfile: IUserProfileResponse; vehicles?: IVehicleFromUsers[] }>(url).pipe(
      map(data => {
        this.serviceStorage.user = data.userProfile;
        this.sessionService.setObject(StorageKeys.USER_PROFILE, data.userProfile);
        localStorage.setItem(
          '@Ford-lang',
          data.userProfile.languages?.preferredLanguage ?? ''
        );
        return data;
      }
      )
    );
  }
}
